import { useState, useEffect, useRef } from 'react';
import { useToastContext } from '@/context/ToastContext';

export interface ServiceErrorToast {
    title: string;
    description: string;
}

export function callApiWithChecks<T>(
    serviceFn: () => Promise<T>,
    deps: any[],
    enabled: boolean,
    errorToast: ServiceErrorToast
): { data: T | null; isLoading: boolean; error: string | null } {
    const { showToast } = useToastContext();
    const [data, setData] = useState<T | null>(null);
    const [isLoading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const fetched = useRef(false);

    useEffect(() => {
        fetched.current = false;
    }, deps);

    useEffect(() => {
        if (!enabled || fetched.current) return;
        setData(null);
        setError(null);
        setLoading(true);
        fetched.current = true;

        serviceFn()
            .then(resp => {
                setData(resp);
                setError(null);
            })
            .catch(err => {
                console.error('Service fetch error:', err);
                setError(errorToast.description);
                showToast({
                    title: errorToast.title,
                    description: errorToast.description,
                    variant: 'error',
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }, [enabled, ...deps]);

    return { data, isLoading, error };
}
